<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-12 ps-md-0">
    <h5>{{localize(langSection.RequestFormPage, langText.LoadedTrailer)}}</h5>

    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.DestinationFacility)}} *</label>
          <ups-select class="{{errors.destinationOrganizationAbbreviatedName ? 'error' : ''}}" [readonly]="isDisabled('destinationOrganizationAbbreviatedName')" [value]="selectedDestination" [list]="destinations" (change)="selectedDestination = $event.target.value"></ups-select>
          @if (errors.destinationOrganizationAbbreviatedName) {
<span class="text-danger">{{errors.destinationOrganizationAbbreviatedName}}</span>
}
        </div>
      </div>
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.DestinationSort)}} *</label>
          <ups-select class="{{errors.destinationSortCode ? 'error' : ''}}" [readonly]="isDisabled('destinationSortCode')" [value]="destinationSortCode" (change)="destinationSortCode = $event.target.value" [list]="sortTypes"></ups-select>
          @if (errors.destinationSortCode) {
<span class="text-danger">{{errors.destinationSortCode}}</span>
}
        </div>
      </div>
    </div>

    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.TrailerType)}} *</label>
          <ups-select class="{{errors.trailerType ? 'error' : ''}}" [readonly]="isDisabled('trailerType')" [value]="model.trailerType" (change)="onFieldChange('trailerType', $event.target.value)" [list]="trailerTypes"></ups-select>
          @if (errors.trailerType) {
<span class="text-danger">{{errors.trailerType}}</span>
}
        </div>
      </div>
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.TrailerNumber)}}</label>
          <input (input)="onFieldChange('trailerNumber', $event.target.value)" mask="AAAAAAAAAAAA" [readonly]="isDisabled('trailerNumber')" [ngModel]="model.trailerNumber" type="text" class="form-control {{errors.trailerNumber ? 'error' : ''}}" />
          @if (errors.trailerNumber) {
<span class="text-danger">{{errors.trailerNumber}}</span>
}
        </div>
      </div>
    </div>

    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.ServiceLevel)}} *</label>
          <ups-select class="{{errors.serviceLevel ? 'error' : ''}}" [readonly]="isDisabled('serviceLevel')" [value]="model.serviceLevel" (change)="onFieldChange('serviceLevel', $event.target.value)" [list]="serviceLevels"></ups-select>
          @if (errors.serviceLevel) {
<span class="text-danger">{{errors.serviceLevel}}</span>
}
        </div>
      </div>
    </div>

    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.Bay)}}</label>
          <input (input)="onFieldChange('bayNumber', $event.target.value)" [ngModel]="model.bayNumber" [readonly]="isDisabled('bayNumber')" type="text" mask="AAAA" class="form-control {{errors.bayNumber ? 'error' : ''}}" />
          @if (errors.bayNumber) {
<span class="text-danger">{{errors.bayNumber}}</span>
}
        </div>
      </div>
    </div>

    <div class="row pt-0">
      <div class="col pt-0">
        <p class="mt-0 fst-italic">{{localize(langSection.RequestFormPage, langText.FillOneOfThree)}} *</p>
      </div>
    </div>

    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.Pieces)}}</label>
          <span class="trailer-info-text {{errors.pieceCount ? errors.pieceCount.length > 1 ? 'error has-error-text' : 'error' : '' }}">
            <input (input)="onFieldChange('pieceCount', $event.target.value)" [ngModel]="model.pieceCount" [readonly]="isDisabled('pieceCount')" type="text" mask="0000" class="form-control" />
          </span>
          @if (errors.pieceCount) {
<span class="text-danger">{{errors.pieceCount}}</span>
}
        </div>
      </div>

      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.Pallets)}}</label>
          <span class="trailer-info-text {{errors.palletCount ? errors.palletCount.length > 1 ? 'error has-error-text' : 'error' : ''}}">
            <input (input)="onFieldChange('palletCount', $event.target.value)" [ngModel]="model.palletCount" [readonly]="isDisabled('palletCount')" type="text" mask="00" class="form-control" />
          </span>
          @if (errors.palletCount) {
<span class="text-danger">{{errors.palletCount}}</span>
}
        </div>
      </div>
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.Fullness)}}</label>
          <span class="trailer-info-text {{(errors.percentFull || errors.percentFullInvalid) ? (errors.percentFull?.length > 1 || errors.percentFullInvalid) ? 'error has-error-text' : 'error' : ''}}">
            <input (input)="onFieldChange('percentFull', $event.target.value)" [ngModel]="model.percentFull" [readonly]="isDisabled('percentFull')" type="text" mask="000" class="form-control" />
          </span>
          @if (errors.percentFull) {
<span class="text-danger">{{errors.percentFull}}</span>
}
          @if (errors.percentFullInvalid) {
<span class="text-danger">{{errors.percentFullInvalid}}</span>
}
        </div>
      </div>
    </div>

    <div class="row pt-0">
      <div class="col pt-0">
        <p class="mt-0 fst-italic">{{localize(langSection.RequestFormPage, langText.OptionalLoadFields)}}</p>
      </div>
    </div>

    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.Gaylords)}}</label>
          <input (input)="onFieldChange('gaylords', $event.target.value)" [ngModel]="model.gaylords" [readonly]="isDisabled('gaylords')" type="text" mask="00" class="form-control {{errors.gaylords ? 'error' : ''}}" />
          @if (errors.gaylords) {
<span class="text-danger">{{errors.gaylords}}</span>
}
        </div>
      </div>

      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.Bags)}}</label>
          <input (input)="onFieldChange('bags', $event.target.value)" [ngModel]="model.bags" [readonly]="isDisabled('bags')" type="text" mask="0000" class="form-control {{errors.bags ? 'error' : ''}}" />
          @if (errors.bags) {
<span class="text-danger">{{errors.bags}}</span>
}
        </div>
      </div>
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.Irregs)}}</label>
          <input (input)="onFieldChange('irregs', $event.target.value)" [ngModel]="model.irregs" [readonly]="isDisabled('irregs')" type="text" mask="0000" class="form-control {{errors.irregs ? 'error' : ''}}" />
          @if (errors.irregs) {
<span class="text-danger">{{errors.irregs}}</span>
}
        </div>
      </div>
    </div>

  </div>
</div>

<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0 mt-3">
  <div class="col-12 ps-md-0">
    <h5>{{localize(langSection.RequestFormPage, langText.AdditionalInformation)}}</h5>
    <div class="row">
      <div class="col-11 col-lg-auto">
        <div class="mb-3 request-input-long">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.RequestReason)}} {{isNewRequest ? '*' : ''}}</label>
          <span class="request-reason-text {{errors.requestReason ? 'error' : ''}}">
            <textarea class="form-control" [ngModel]="model.requestReason" [readonly]="isDisabled('requestReason')" maxlength="256" (input)="onFieldChange('requestReason', $event.target.value)"></textarea>
          </span>
          @if (errors.requestReason) {
<span class="text-danger">{{errors.requestReason}}</span>
}
        </div>
      </div>
    </div>

    @if (model.requestType === 'Switch') {
<div class="row">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="mb-3 request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.DeliveryNumber)}}</label>
          <input type="text" class="form-control {{errors.deliveryNumber ? 'error' : ''}}" [ngModel]="model.deliveryNumber" [readonly]="isDisabled('deliveryNumber')" maxlength="30" (input)="onFieldChange('deliveryNumber', $event.target.value)" />
          @if (errors.deliveryNumber) {
<span class="text-danger">{{errors.deliveryNumber}}</span>
}
        </div>
      </div>
    </div>
}

    <div class="row">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="mb-3 request-input-short">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.PickupNumber)}}</label>
          <input type="text" class="form-control {{errors.pickUpNumber ? 'error' : ''}}" [ngModel]="model.pickUpNumber" [readonly]="isDisabled('pickUpNumber')" maxlength="30" (input)="onFieldChange('pickUpNumber', $event.target.value)" />
          @if (errors.pickUpNumber) {
<span class="text-danger">{{errors.pickUpNumber}}</span>
}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-11 col-lg-auto">
        <div class="mb-3 request-input-long">
          <label class="fw-bold form-label">{{localize(langSection.RequestFormPage, langText.SpecialInstructions)}}</label>
          <textarea class="form-control {{errors.specialInstructions ? 'error' : ''}}" [ngModel]="model.specialInstructions" [readonly]="isDisabled('specialInstructions')" maxlength="256" (input)="onFieldChange('specialInstructions', $event.target.value)"></textarea>
          @if (errors.specialInstructions) {
<span class="text-danger">{{errors.specialInstructions}}</span>
}
        </div>
      </div>
    </div>
  </div>
</div>
